/**
 * XPR Network chain constants and configuration.
 */

export const CHAIN_ID =
  '384da888112027f0321850a169f737c33e53b388aad48b5adace4bab97f437e0';

/** Minimum number of BP approvals required to execute the msig (2/3 + 1). */
export const REQUIRED_APPROVALS = 15;

/** Total active block producers in the schedule. */
export const TOTAL_BPS = 21;

/** Available RPC API endpoints. */
export const API_ENDPOINTS = [
  { url: 'https://proton.eosusa.io', label: 'proton.eosusa.io' },
  { url: 'https://api.protonnz.com', label: 'api.protonnz.com' },
  { url: 'https://proton.greymass.com', label: 'proton.greymass.com' },
  { url: 'https://proton.cryptolions.io', label: 'proton.cryptolions.io' },
];

/** Default API endpoint. */
export const DEFAULT_API_URL = API_ENDPOINTS[0].url;

/** App identifier used for ProtonWebSDK session management. */
export const APP_IDENTIFIER = 'xprmsigapp';

